import React, { useContext, useEffect, useRef, useState } from "react";
import Box from "@mui/material/Box";
import Header from "../component/Header/Header";
import Footer from "../component/Footer/Footer";
import Sidebar from "../component/Sidebar/Sidebar";
import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";
import dummy from "../assets/DummyImage.png";
import bifurcateCategoriesAndItems, { categories } from "../utils/jsonconverter";
import { Alert, Button, Chip, IconButton, Paper, Snackbar, Typography, Select, MenuItem } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import RemoveIcon from "@mui/icons-material/Remove";
import { useDispatch, useSelector } from "react-redux";
import { pushStoreData } from "../redux/slice/StoreSlice";
import NotInterestedIcon from '@mui/icons-material/NotInterested';
import "./Home.css";
import { addCart, addItem, removeOffer, decreaseQtyFromCatalogue, clearCart, applyOrderLevelCharge } from "../redux/slice/CartSlice";
import axiosApiFunction from "../utils/axiosapifunc";
import { showApiErrorToast } from "../utils/toastHelper";
import Spinner from "../component/Spinner/Spinner";
import "../component/Grid/ProductGrid.css";
import BOGOProductTile from "../component/BOGO/BOGOProductTile";
import OfferScroller from "../component/OffersAndRecommendation/OfferScroller";
import RecommendedItems from "../component/OffersAndRecommendation/RecommendedItems";
import DialogComp from "../component/ModalComp/DialogComp";
import AddToCartPopUp from "../component/PopUp/AddToCartPopUp";
import StoreLocationPopup from "../component/ModalComp/StoreLocationPopup";
import BOGOWizard from "../component/ModalComp/BOGOWizard";
import SearchModal from "../component/ModalComp/SearchModal";
import OfferContext from "../context/OfferContext";
import LocationContext from "../context/LocationContext";
import ErrorContext from "../context/ErrorContext";
import NearMeOutlinedIcon from '@mui/icons-material/NearMeOutlined';
import SearchIcon from '@mui/icons-material/Search';
import { styled, alpha } from '@mui/material/styles';
import InputBase from '@mui/material/InputBase';
import StorefrontOutlinedIcon from '@mui/icons-material/StorefrontOutlined';
import PhoneIphoneOutlinedIcon from '@mui/icons-material/PhoneIphoneOutlined';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import ScrollBottomToTop from "../component/Button/ScrollBottomToTop";
import sbp from"../../src/assets/sort.png";
import calcdeliverycharge from "../utils/calcdeliverycharge";
import { ensureCartData } from "../utils/cartStorage";

function HomePage() {
    const [offers, setOffers] = useState([]);
    const [recommendedItems, setRecommendedItems] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState();
    const [category, setCategory] = useState([]);
    const [bogoCategory, setBogoCategory] = useState([]);
    const [expandedDescriptions, setExpandedDescriptions] = useState({});
    const [open, setOpen] = React.useState(false);
    const [message, setMessage] = useState('');
    const [severity, setSeverity] = useState('success');
    const [isLoading, setIsLoading] = useState(true);
    const [isLocationLoading, setIsLocationLoading] = useState(true);
    const [isOffersLoading, setIsOffersLoading] = useState(true);
    const [isMenuLoading, setIsMenuLoading] = useState(true);
    const [openDialog, setOpenDialog] = useState(false);
    const [openSearchDialog, setOpenSearchDialog] = useState(false);
    const [showPopup, setShowPopup] = useState(false);
    const [searchItems, setSearchItems] = useState([]);
    const [dialogItem, setDialogItem] = useState([]);
    const [sortOrder, setSortOrder] = useState('');
    const [stores, setStores] = useState([]);
    const [showLocationPopup, setShowLocationPopup] = useState(false);
    const [showBogoPopup, setShowBogoPopup] = useState(false);
    const [selectedBogoCategoryId, setSelectedBogoCategoryId] = useState("");
    const [hasLoggedStoreInfo, setHasLoggedStoreInfo] = useState(false);
    const locationCtx = useContext(LocationContext);
    const {apiError, setApiError, clearApiError}= useContext(ErrorContext);
    const totalDiscount = useSelector((state) => state.cart?.totalDiscount);
    const getStore = useSelector((state) => state.store?.storeData);
    const cartItems = useSelector((state)=>state.cart?.cartData);
    const offerCtx = useContext(OfferContext);
    const [currentLocationId, setCurrentLocationId] = useState(0);
  
    const handleClose = (event, reason) => {
      if (reason === 'clickaway') {
        return;
      }
  
      setOpen(false);
    };

    const toggleReadMore = (itemId) => {
        setExpandedDescriptions(prevState => ({
            ...prevState,
            [itemId]: !prevState[itemId]
        }));
    };

    const dispatch = useDispatch();
    const categoryRefs = useRef({});

    const handleCategorySelect = (categoryId) => {
        setSelectedCategory(categoryId);
        if (categoryRefs.current[categoryId]) {
            categoryRefs.current[categoryId].scrollIntoView({
                behavior: "smooth",
                block: "start",
            });
        }
    };

    const handleLocationSelect = (location) => {
        localStorage.setItem('locationData', JSON.stringify(location));
        localStorage.setItem('locationId', Number(location.locationid));
        locationCtx.handleLocationChange(location);
        setCurrentLocationId(Number(location.locationid));
        dispatch(clearCart());
        setShowLocationPopup(false);  // Close the pop-up
    };

    const convertToPlainObject = (obj) => {
        if (obj instanceof Object) {
          return {
            refId: obj.refId,
            title: obj.title,
            options: obj.options.map(option => ({ ...option })),
            sortOrder: obj.sortOrder,
            item_ref_ids: [...obj.item_ref_ids]
          };
        }
        return obj;
      };
      
      const convertOptionToPlainObject = (option) => {
        if (option && Object.keys(option).length === 0 && option.constructor === Object) {
            return {};
        }

        if (option instanceof Object) {
            return {
                refId: option.refId,
                title: option.title,
                groupRefID: option.groupRefID,
                groupTitle: option.groupTitle,
                description: option.description,
                weight: option.weight,
                available: option.available,
                price: option.price,
                markupPrice: option.markupPrice,
                soldAtStore: option.soldAtStore,
                sortOrder: option.sortOrder,
                optGroupRefIds: [option?.optGroupRefIds],
                nestedOptGroups: [option?.nestedOptGroups],
                foodType: option.foodType
            };
        }
        return option;
    };

    const handleAddToCartClosePopup = () => {
        setShowPopup(false);
      };

    const addProductToCart = (item, firstVariationPrice) => {
        if (category?.linkoffer) {
            if(category.linkoffer == "1") {
                setSelectedBogoCategoryId(category.refId);
                setShowBogoPopup(true);
                return;
            }
        }
        if (item.available == 1 || item.available == true) {
            if(item?.optionsToAdd?.length > 0 ? false : item.optionGroups.length > 0 ){
                setOpenDialog(true);
                setDialogItem(item);
            }else{
                setShowPopup(true);
                // setMessage('Product added to cart successfully!');
                // setSeverity('success');
                const itemData = {
                    available: item.available,
                    currentStock: Number(item.currentStock),
                    description: item.description,
                    foodType: item.foodType,
                    imgUrl: item.imgUrl,
                    markupPrice: item.markupPrice,
                    // optionGroups: item.optionGroups ? item.optionGroups.map(group => convertToPlainObject(group)) : [],
                    price: item.price,
                    recommended: item.recommended,
                    refId: Number(item.refId),
                    title: item.title,
                    categoryRefIds: item.categoryRefIds,
                    soldAtStore: item.soldAtStore,
                    sortOrder: item.sortOrder,
                    weight: item.weight,
                    quantity: item.quantity || 1,
                    totalPrice: Number(
                        item.price === 0
                            ? firstVariationPrice
                            : item.price === firstVariationPrice
                            ? item.price
                            : item.price + firstVariationPrice
                    ),
                    itemTotalTax: 0,
                    offerId: 0,
                    offerName: '',
                    linkOffer: category?.linkoffer ? parseInt(category.linkoffer) : 0,
                    BOGOOffer: category?.offerid ? parseInt(category.offerid) : 0,
                    instructions: '',
                    discount: 0,
                    productPortionId: 0,
                    taxProfileId: 0,
                    portionName: "",
                    optionsToAdd: item.optionsToAdd ? item.optionsToAdd.map(option => convertOptionToPlainObject(option)) : [],
                    chargesArray: getStore?.charges || []
                  };
                
                if(totalDiscount > 0) {
                    offerCtx.resetOffer();
    
                    const offerData = {
                        offername: "",
                        offerdescription: "",
                        isofferapplied: false
                    }
                    localStorage.setItem('offerData', JSON.stringify(offerData));
                    dispatch(removeOffer());
                    dispatch(addItem(itemData));
                } else {
                    dispatch(addItem(itemData));
                }

                setOpen(true);
            }
          } else {
            setMessage('Product is not available!');
            setSeverity('error');
          }
          item.optionsToAdd = [];
      };
      
      setTimeout(() => {
        setOpen(false);
      }, 2500);


    // Effect A — Fetch store locations (runs once on mount)
    useEffect(() => {
        clearApiError();
        setIsLoading(true);
        setIsLocationLoading(true);

        const companyId = JSON.parse(localStorage.getItem('companyId'));

        const fetchStoreLocation = async () => {
            const locationData = JSON.parse(localStorage.getItem("locationData"));
            const locationId = JSON.parse(localStorage.getItem("locationId"));

            try {
                const storesDetails = await axiosApiFunction(
                    "get",
                    "/api/v1/getbopisstores",
                    { companyid: companyId }
                );

                setStores(storesDetails.data);
                if (locationData) {
                    locationCtx.handleLocationChange(locationData);
                    setCurrentLocationId(Number(localStorage.getItem('locationId')));
                } else {
                    localStorage.setItem("locationData", JSON.stringify(storesDetails.data[0]));
                    locationCtx.handleLocationChange(storesDetails.data[0]);
                    setCurrentLocationId(Number(locationId));
                }
            } catch (error) {
                showApiErrorToast('/api/v1/getbopisstores', error, 'Failed to fetch store locations');
                setApiError(error.message);
                setIsLoading(false);
            } finally {
                setIsLocationLoading(false);
            }
        };

        fetchStoreLocation();

        // Ensure cartData key exists and get data
        const cartdata = ensureCartData();
        if(cartdata && cartdata.length > 0) {
            dispatch(addCart(cartdata));
        }
    }, []);

    // Effect B — Fetch menu, offers, store details (runs when currentLocationId is set)
    useEffect(() => {
        if (currentLocationId === 0) return;

        setIsOffersLoading(true);
        setIsMenuLoading(true);
        setIsLoading(true);

        const companyId = JSON.parse(localStorage.getItem('companyId'));

        const fetchOfferData = async () => {
            const locationData = JSON.parse(localStorage.getItem("locationData"));

            try {
                const response = await axiosApiFunction(
                    "get",
                    "/api/v1/getoffers",
                    { companyid: companyId, locationid: Number(locationData.locationid)}
                );
                setOffers(response.data);
            } catch (error) {
                showApiErrorToast('/api/v1/getoffers', error, 'Failed to fetch offers');
                setApiError(error.message);
                setIsLoading(false);
            } finally {
                setIsOffersLoading(false);
            }
        };

        const fetchData = async () => {
            try {
                const menuData = await axiosApiFunction('get', '/api/v1/fetchmenu', { companyid: companyId, locationid: currentLocationId }
                );
        
                localStorage.setItem('menuData', JSON.stringify(menuData.data[0].menudata))
                let categoriesJson = menuData.data[0].menudata.categories;
                let itemsJson = menuData.data[0].menudata.items;
                let optionGroupsJson = menuData.data[0].menudata.option_groups;
                let optionsJson = menuData.data[0].menudata.options;
                let combinedItems = [];

                bifurcateCategoriesAndItems(categoriesJson, itemsJson, optionGroupsJson, optionsJson);
                
                // const updatedCategories = updateCategoriesWithDaySlots(categories, daySlotsData);

                // console.log("categories", categories)

                const filteredCategories = filterCategoriesByDayAndTime(categories);
                
                setCategory(filteredCategories);
                setBogoCategory(filteredCategories.filter(category => category.linkoffer == "1" && parseInt(category.offerid) > 0));

                if (filteredCategories.length > 0) {
                    setSelectedCategory(filteredCategories[0].refId);
                }

                let allItems = [];

                filteredCategories.forEach((category) => {
                    if (category.items && category.items.length > 0) {
                        allItems = [
                            ...allItems,
                            ...category.items.filter((item) => item.recommended === true),
                        ];
                    }

                    category.subCategories.forEach((subCategory) => {
                        if (subCategory.items && subCategory.items.length > 0) {
                            allItems = [
                                ...allItems,
                                ...subCategory.items.filter((item) => item.recommended === true),
                            ];
                        }
                    });
                });

                  setRecommendedItems(allItems);
                  localStorage.setItem('recommended', JSON.stringify(allItems));

                for (let i = 0; i < filteredCategories.length; i++) {
                    const currentItem = filteredCategories[i];

                    if (currentItem.items && currentItem.items.length > 0) {
                        combinedItems = [...combinedItems, ...currentItem.items];
                    }

                    if (currentItem.subCategories && currentItem.subCategories.length > 0) {
                        for (let j = 0; j < currentItem.subCategories.length; j++) {
                            const subCategory = currentItem.subCategories[j];
                            if (subCategory.items && subCategory.items.length > 0) {
                                combinedItems = [...combinedItems, ...subCategory.items];
                            }
                        }
                    }
                }

                setSearchItems(combinedItems);
            } catch (error) {
                showApiErrorToast('/api/v1/fetchmenu', error, 'Failed to fetch menu data');
                setIsLoading(false);
                setApiError(error.message);
            }

            try {
                const storeDetails = await axiosApiFunction('get', '/api/v1/getstoredetails', { companyid: companyId, locationid: currentLocationId }
                );
                dispatch(pushStoreData(storeDetails.data[0]));
                localStorage.setItem("locationData", JSON.stringify(storeDetails.data[0]));
            } catch (error) {
                showApiErrorToast('/api/v1/getstoredetails', error, 'Failed to fetch store details');
                setApiError(error.message);
            } finally {
                setIsMenuLoading(false);
            }
        };

        const fetchMenuAndOffers = async () => {
            try {
                await fetchOfferData();
                await fetchData();
            } catch (error) {
                showApiErrorToast('fetchMenuAndOffers', error, 'Failed to load page data');
                setApiError(error.message);
                setIsLoading(false);
            }
        };

        fetchMenuAndOffers();
    }, [currentLocationId]);

    useEffect(() => {
        if (!isLocationLoading && !isOffersLoading && !isMenuLoading) {
            setIsLoading(false);
        }
    }, [isLocationLoading, isOffersLoading, isMenuLoading]);

    useEffect(() => {
        // cartItems.forEach((item) => {
            // if(item?.isOrderLevelChargedProduct == true){
                // dispatch(applyOrderLevelCharge(Number(getStore?.charges?.find(charge => charge.applicableon == 2).chargevalue)))
                if(cartItems.length > 0){
                    let userData =  JSON.parse(localStorage.getItem('userData'));
                    
                    if (!userData?.distance || !getStore?.deliverycharge_data) {
                        return; // Exit early if either is missing
                    }

                    const deliveryChargePerDistance = calcdeliverycharge(userData?.distance || 0, getStore.deliverycharge_data);
                    dispatch(applyOrderLevelCharge(deliveryChargePerDistance.charge));
                }
            // }
        // })
    }, [getStore])

    // Send store time info after page is fully loaded
    useEffect(() => {
        // Check if page is fully loaded and we haven't sent the info yet
        if (!isLoading && !hasLoggedStoreInfo && getStore && Object.keys(getStore).length > 0 && getStore.timings) {
            // Add a small delay to ensure everything is rendered
            const timer = setTimeout(() => {
                sendStoreTimeInfo();
                setHasLoggedStoreInfo(true);
            }, 1000);

            return () => clearTimeout(timer);
        }
    }, [isLoading, hasLoggedStoreInfo, getStore]);

    const filterCategoriesByDayAndTime = (categories) => {
        const now = new Date();
        const currentDay = now.toLocaleString('en-US', { weekday: 'long' }).toLowerCase();
        const currentTime = now.getHours() * 60 + now.getMinutes(); // Convert current time to minutes
    
        return categories.filter(category => {
            if (!category.day_slots || category.day_slots.length === 0) {
                return true; // Keep categories that have no time restrictions
            }
    
            const daySlot = category.day_slots.find(slot => slot.day.toLowerCase() === currentDay);
            if (!daySlot) {
                return false; // Remove category if there's no matching day
            }
    
            // Check if current time falls within any of the time slots for the day
            const isTimeValid = daySlot.slots.some(slot => {
                const startTime = parseInt(slot.start_time.split(':')[0]) * 60 + parseInt(slot.start_time.split(':')[1]);
                const endTime = parseInt(slot.end_time.split(':')[0]) * 60 + parseInt(slot.end_time.split(':')[1]);
    
                return currentTime >= startTime && currentTime <= endTime;
            });
    
            return isTimeValid;
        });
    };

    const handleSortChange = (event) => {
        const order = event.target.value;
        setSortOrder(order);
        sortItems(order);
    };

    const sortItems = (order) => {
        const getEffectivePrice = (item) => {
            if (item.price != 0) {
                return item.price;
            }
            const optionGroup = item.optionGroups?.find(
                (group) => group.refId == item.refId
            );
            if (optionGroup?.options?.length > 0) {
                return optionGroup.options[0].price || 0; // Fallback to 0 if price is not found
            }
            return 0; // Default price when no valid options or optionGroups are found
        };

        const sortedCategories = category.map(cat => ({
            ...cat,
            items: [...cat.items].sort((a, b) => {
                const priceA = getEffectivePrice(a);
                const priceB = getEffectivePrice(b);

                if (order === 'asc') {
                    return priceA - priceB;
                }
                return priceB - priceA;
            }),
            subCategories: cat.subCategories.map(subCat => ({
                ...subCat,
                items: [...subCat.items].sort((a, b) => {
                    const priceA = getEffectivePrice(a);
                    const priceB = getEffectivePrice(b);

                    if (order === 'asc') {
                        return priceA - priceB;
                    }
                    return priceB - priceA;
                })
            }))
        }));
        setCategory(sortedCategories);
    };
    
    const formatTimeTo12Hour = (time24) => {
        const [hour, minute] = time24.split(':');
        const hourInt = parseInt(hour, 10);
        const period = hourInt >= 12 ? 'PM' : 'AM';
        const hour12 = hourInt % 12 || 12;
        return `${hour12}:${minute} ${period}`;
    };

    const isStoreOpen = (timings) => {
        const now = new Date();
        const currentDay = now.toLocaleString("en-US", { weekday: "long" }).toLowerCase();
        const currentTime = now.toTimeString().slice(0, 8);

        const getPriviousDay = (dayIndex) => {
            return dayIndex === 0 ? timings.length - 1 : dayIndex - 1;
        };

        const currentDayIndex = timings.findIndex((timing) => timing.day === currentDay);

        if (currentDayIndex === -1) {
            return false;
        }

        for (const timing of timings) {
            if (timing.day === currentDay) {
                for (const slot of timing.slots) {
                    const startTime = slot.start_time.slice(0, 8);
                    const endTime = slot.end_time.slice(0, 8);

                    if (startTime < endTime) {
                        if (currentTime >= startTime && currentTime < endTime) {
                            return true;
                        }
                    } else {
                        const previousDayIndex = getPriviousDay(currentDayIndex);
                        const previousDayTimings = timings[previousDayIndex];

                        for (const slot of previousDayTimings.slots) {
                            const previousDayEndTime = slot.end_time.slice(0, 8);

                            if (currentTime >= startTime) {
                                return true;
                            }

                            if (currentTime < previousDayEndTime) {
                                return true;
                            } else {
                                return false;
                            }
                        }
                    }
                }
            }
        }

        return false;
    };
    

    const getNextOpeningTime = (timings) => {
        const now = new Date();
        const currentDay = now.toLocaleString("en-US", { weekday: "long" }).toLowerCase(); // e.g., 'monday'
        const currentTime = now.toTimeString().slice(0, 8); // 'HH:MM'

        const getPriviousDay = (dayIndex) => {
            return dayIndex === 0 ? timings.length - 1 : dayIndex - 1;
        };

        const currentDayIndex = timings.findIndex((timing) => timing.day === currentDay);

        for (const timing of timings) {
            if (timing.day === currentDay) {
                for (const slot of timing.slots) {
                    const startTime = slot.start_time.slice(0, 8);
                    const endTime = slot.end_time.slice(0, 8);

                    if (startTime < endTime) {
                        if (currentTime >= startTime && currentTime < endTime) {
                            return `Open until ${formatTimeTo12Hour(endTime)}`;
                        }
                    } else {
                        const previousDayIndex = getPriviousDay(currentDayIndex);
                        const previousDayTimings = timings[previousDayIndex];

                        for (const slot of previousDayTimings.slots) {
                            const previousDayEndTime = slot.end_time.slice(0, 8);

                            if (currentTime >= startTime) {
                                return `Open until ${formatTimeTo12Hour(endTime)}`;
                            }

                            if (currentTime < previousDayEndTime) {
                                return `Open until ${formatTimeTo12Hour(previousDayEndTime)}`;
                            } else {
                            }
                        }
                    }
                }
            }
        }

        for (const timing of timings) {
            if (timing.day === currentDay) {
                for (const slot of timing.slots) {
                    const startTime = slot.start_time.slice(0, 8);

                    if (currentTime < startTime) {
                        return `Opens next on ${
                            currentDay.charAt(0).toUpperCase() + currentDay.slice(1)
                        } at ${formatTimeTo12Hour(startTime)}`;
                    }
                }
            }
        }

        for (let i = 1; i < timings.length; i++) {
            const nextDayTiming = timings[(currentDayIndex + i) % timings.length];
            if (nextDayTiming.slots.length > 0) {
                return `Opens next on ${
                    nextDayTiming.day.charAt(0).toUpperCase() + nextDayTiming.day.slice(1)
                } at ${formatTimeTo12Hour(nextDayTiming.slots[0].start_time)}`;
            }
        }
        return "No available opening times";
    };

    const Search = styled('div')(({ theme }) => ({
        position: 'relative',
        borderRadius: theme.shape.borderRadius,
        backgroundColor: alpha(theme.palette.common.white, 0.15),
        '&:hover': {
          backgroundColor: alpha(theme.palette.common.white, 0.25),
        },
        marginLeft: 0,
        width: '100%',
        [theme.breakpoints.up('sm')]: {
          marginLeft: theme.spacing(1),
          width: 'auto',
        },
      }));

      const SearchIconWrapper = styled('div')(({ theme }) => ({
        padding: theme.spacing(0, 2),
        height: '100%',
        position: 'absolute',
        pointerEvents: 'none',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }));

      const StyledInputBase = styled(InputBase)(({ theme }) => ({
        color: 'inherit',
        width: '100%',
        '& .MuiInputBase-input': {
          padding: theme.spacing(1, 1, 1, 0),
          // vertical padding + font size from searchIcon
          paddingLeft: `calc(1em + ${theme.spacing(4)})`,
          transition: theme.transitions.create('width'),
          [theme.breakpoints.up('sm')]: {
            width: '12ch',
            '&:focus': {
              width: '20ch',
            },
          },
        },
      }));

      const isProductInCart = (item) => {
        return cartItems?.some(cartItem => cartItem.refId == item.refId);
      };
      
      const getProductQuantityInCart = (item) => {
          return cartItems
              ?.filter((cartItem) => cartItem.refId == item.refId)
              ?.reduce((total, cartItem) => total + cartItem.quantity, 0);
      };

      const handleSearch = () => {
        setOpenSearchDialog(true);
      }

      const handleLocationClick = () => {
          const googleMapsUrl = `https://www.google.com/maps/dir//${Number(
              getStore.latitude
          )},${Number(getStore.longitude)}`;
          window.open(googleMapsUrl, "_blank");
      };

      const renderSkeleton = () => (
        <Grid item xs={12} sm={6} md={6} lg={3} className="item-cart-category">
          <Paper className="product-card">
            <div className="product-box-wc">
              <Skeleton variant="rectangular" width="100%" height={150} sx={{bgcolor: "#d3d3d3"}} />
              <div className="pro-contentbox">
                <Skeleton variant="text" width="80%" animation="wave" sx={{bgcolor: "#d3d3d3"}} />
                <Skeleton variant="text" width="60%" animation="wave" sx={{bgcolor: "#d3d3d3"}} />
                <Skeleton variant="text" width="40%" animation="wave" sx={{bgcolor: "#d3d3d3"}} />
              </div>
            </div>
            <div className="product-actions">
                <div>
                </div>
                <div className="addtocart-skeleton-button">
                    <Skeleton variant="circular" width={40} height={40} animation="wave" className="circular-skeleton"/>
                </div>
            </div>
          </Paper>
        </Grid>
      );

    const handleDialPadOpen = (phone) => {
        // Use `tel:` link to open the dial pad
        window.location.href = `tel:${phone}`;
    };

    // Utility functions to collect device and browser information
    const getDeviceInfo = () => {
        const userAgent = navigator.userAgent;

        // Modern approach using userAgentData API, fallback to userAgent parsing
        const platform = navigator.userAgentData?.platform ||
                        (userAgent.includes('Win') ? 'Win32' :
                         userAgent.includes('Mac') ? 'MacIntel' :
                         userAgent.includes('Linux') ? 'Linux' :
                         userAgent.includes('Android') ? 'Android' :
                         userAgent.includes('iPhone') || userAgent.includes('iPad') ? 'iOS' : 'Unknown');

        // Detect vendor from userAgent without using deprecated navigator.vendor
        const vendor = userAgent.includes('Edg/') || userAgent.includes('Edge/') ? 'Microsoft Corporation' :
                      userAgent.includes('Chrome') && !userAgent.includes('Edg') ? 'Google Inc.' :
                      userAgent.includes('Safari') && userAgent.includes('Apple') && !userAgent.includes('Chrome') ? 'Apple Computer, Inc.' :
                      userAgent.includes('Firefox') ? 'Mozilla' :
                      userAgent.includes('Opera') || userAgent.includes('OPR') ? 'Opera Software ASA' : '';

        // Detect OS with more detail
        let os = "Unknown";
        let osVersion = "";

        // iOS Detection (iPhone, iPad, iPod)
        if (/iPhone/.test(userAgent)) {
            os = "iOS (iPhone)";
            const match = userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/);
            if (match) osVersion = match[1] + "." + match[2] + (match[3] ? "." + match[3] : "");
        } else if (/iPad/.test(userAgent)) {
            os = "iOS (iPad)";
            const match = userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/);
            if (match) osVersion = match[1] + "." + match[2] + (match[3] ? "." + match[3] : "");
        } else if (/iPod/.test(userAgent)) {
            os = "iOS (iPod)";
            const match = userAgent.match(/OS (\d+)_(\d+)_?(\d+)?/);
            if (match) osVersion = match[1] + "." + match[2] + (match[3] ? "." + match[3] : "");
        }
        // Android Detection
        else if (/Android/.test(userAgent)) {
            os = "Android";
            const match = userAgent.match(/Android (\d+(?:\.\d+)*)/);
            if (match) osVersion = match[1];
        }
        // Windows Detection
        else if (/Win/.test(userAgent)) {
            os = "Windows";
            if (/Windows NT 10/.test(userAgent)) osVersion = "10/11";
            else if (/Windows NT 6.3/.test(userAgent)) osVersion = "8.1";
            else if (/Windows NT 6.2/.test(userAgent)) osVersion = "8";
            else if (/Windows NT 6.1/.test(userAgent)) osVersion = "7";
            else if (/Windows NT 6.0/.test(userAgent)) osVersion = "Vista";
            else if (/Windows NT 5.1/.test(userAgent)) osVersion = "XP";
        }
        // MacOS Detection
        else if (/Mac/.test(userAgent) && !/Mobile/.test(userAgent)) {
            os = "MacOS";
            const match = userAgent.match(/Mac OS X (\d+)[._](\d+)[._]?(\d+)?/);
            if (match) osVersion = match[1] + "." + match[2] + (match[3] ? "." + match[3] : "");
        }
        // Linux Detection
        else if (/Linux/.test(userAgent) && !/Android/.test(userAgent)) {
            os = "Linux";
        }
        // Chrome OS
        else if (/CrOS/.test(userAgent)) {
            os = "Chrome OS";
        }

        // Detect Browser with correct priority (most specific first)
        let browser = "Unknown";
        let browserVersion = "";

        // Edge (Chromium-based)
        if (/Edg\//.test(userAgent)) {
            browser = "Edge (Chromium)";
            const match = userAgent.match(/Edg\/(\d+(?:\.\d+)*)/);
            if (match) browserVersion = match[1];
        }
        // Edge (Legacy)
        else if (/Edge\//.test(userAgent)) {
            browser = "Edge (Legacy)";
            const match = userAgent.match(/Edge\/(\d+(?:\.\d+)*)/);
            if (match) browserVersion = match[1];
        }
        // Samsung Internet
        else if (/SamsungBrowser/.test(userAgent)) {
            browser = "Samsung Internet";
            const match = userAgent.match(/SamsungBrowser\/(\d+(?:\.\d+)*)/);
            if (match) browserVersion = match[1];
        }
        // Opera
        else if (/OPR\/|Opera/.test(userAgent)) {
            browser = "Opera";
            const match = userAgent.match(/(?:OPR|Opera)\/(\d+(?:\.\d+)*)/);
            if (match) browserVersion = match[1];
        }
        // UC Browser
        else if (/UCBrowser/.test(userAgent)) {
            browser = "UC Browser";
            const match = userAgent.match(/UCBrowser\/(\d+(?:\.\d+)*)/);
            if (match) browserVersion = match[1];
        }
        // Firefox
        else if (/Firefox/.test(userAgent)) {
            browser = "Firefox";
            const match = userAgent.match(/Firefox\/(\d+(?:\.\d+)*)/);
            if (match) browserVersion = match[1];
        }
        // Chrome (must be before Safari)
        else if (/Chrome/.test(userAgent) && /Google Inc/.test(vendor)) {
            browser = "Chrome";
            const match = userAgent.match(/Chrome\/(\d+(?:\.\d+)*)/);
            if (match) browserVersion = match[1];
        }
        // Safari (must be after Chrome)
        else if (/Safari/.test(userAgent) && /Apple/.test(vendor)) {
            browser = "Safari";
            const match = userAgent.match(/Version\/(\d+(?:\.\d+)*)/);
            if (match) browserVersion = match[1];
        }
        // Internet Explorer
        else if (/MSIE|Trident/.test(userAgent)) {
            browser = "Internet Explorer";
            const match = userAgent.match(/(?:MSIE |rv:)(\d+(?:\.\d+)*)/);
            if (match) browserVersion = match[1];
        }

        // Detect Device Type with more accuracy
        let deviceType = "Desktop";
        let deviceModel = "Unknown";

        // Mobile Detection
        if (/Mobi|Android/i.test(userAgent) && !/Tablet|iPad/i.test(userAgent)) {
            deviceType = "Mobile";

            // Try to get device model for Android
            if (/Android/.test(userAgent)) {
                const modelMatch = userAgent.match(/Android.*;\s*([^)]+)\s*Build/);
                if (modelMatch) deviceModel = modelMatch[1].trim();
            }

            // iPhone model detection
            if (/iPhone/.test(userAgent)) {
                deviceModel = "iPhone";
            }
        }
        // Tablet Detection
        else if (/Tablet|iPad/i.test(userAgent) || (/Android/.test(userAgent) && !/Mobi/.test(userAgent))) {
            deviceType = "Tablet";

            if (/iPad/.test(userAgent)) {
                deviceModel = "iPad";
            } else {
                const modelMatch = userAgent.match(/Android.*;\s*([^)]+)\s*Build/);
                if (modelMatch) deviceModel = modelMatch[1].trim();
            }
        }
        // Desktop
        else {
            deviceType = "Desktop";
            deviceModel = platform || "Unknown";
        }

        // Get Screen Info
        const screenWidth = window.screen.width;
        const screenHeight = window.screen.height;
        const viewportWidth = window.innerWidth;
        const viewportHeight = window.innerHeight;
        const screen = `${screenWidth}x${screenHeight}`;
        const viewport = `${viewportWidth}x${viewportHeight}`;
        const pixelRatio = window.devicePixelRatio || 1;

        // Detect orientation
        const orientation = window.screen.orientation
            ? window.screen.orientation.type
            : (screenWidth > screenHeight ? "landscape" : "portrait");

        // Check touch capability
        const touchEnabled = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

        // Get connection info if available
        let connectionType = "Unknown";
        if (navigator.connection || navigator.mozConnection || navigator.webkitConnection) {
            const connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
            connectionType = connection.effectiveType || connection.type || "Unknown";
        }

        return {
            os: osVersion ? `${os} ${osVersion}` : os,
            browser: browserVersion ? `${browser} ${browserVersion}` : browser,
            deviceType,
            deviceModel,
            screen,
            viewport,
            pixelRatio,
            orientation,
            touchEnabled,
            connectionType,
            userAgent: userAgent,
            platform: platform
        };
    };

    const getStoreTimingInfo = () => {
        const tableId = JSON.parse(localStorage.getItem('tblid')) || 0;
        const tableName = JSON.parse(localStorage.getItem('tblname')) || "";

        if (!getStore || !getStore.timings) {
            return {
                openTime: "N/A",
                closeTime: "N/A",
                status: "Unknown",
                tableId: tableId,
                tableName: tableName
            };
        }

        const now = new Date();
        const currentDay = now.toLocaleString("en-US", { weekday: "long" }).toLowerCase();

        // Find current day timings
        const todayTimings = getStore.timings.find(timing => timing.day === currentDay);

        if (!todayTimings || !todayTimings.slots || todayTimings.slots.length === 0) {
            return {
                openTime: "Closed Today",
                closeTime: "Closed Today",
                status: "Closed",
                tableId: tableId,
                tableName: tableName
            };
        }

        // Get first slot's start time and last slot's end time
        const openTime = todayTimings.slots[0]?.start_time || "N/A";
        const closeTime = todayTimings.slots[todayTimings.slots.length - 1]?.end_time || "N/A";
        const status = isStoreOpen(getStore.timings) ? "Open" : "Closed";

        return {
            openTime,
            closeTime,
            status,
            tableId: tableId,
            tableName: tableName
        };
    };

    const sendStoreTimeInfo = async () => {
        try {
            const now = new Date();
            const companyId = JSON.parse(localStorage.getItem('companyId'));
            const locationId = JSON.parse(localStorage.getItem('locationId'));

            const storeInfo = getStoreTimingInfo();
            const deviceInfo = getDeviceInfo();

            const payload = {
                localTime: now.toLocaleString("en-US", {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit',
                    hour12: false
                }),
                browserTimezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                apiTime: new Date().toISOString(),
                device: {
                    os: deviceInfo.os,
                    browser: deviceInfo.browser,
                    deviceType: deviceInfo.deviceType,
                    deviceModel: deviceInfo.deviceModel,
                    screen: deviceInfo.screen,
                    viewport: deviceInfo.viewport,
                    pixelRatio: deviceInfo.pixelRatio,
                    orientation: deviceInfo.orientation,
                    touchEnabled: deviceInfo.touchEnabled,
                    connectionType: deviceInfo.connectionType,
                    userAgent: deviceInfo.userAgent,
                    platform: deviceInfo.platform
                },
                store: storeInfo,
                companyId: companyId,
                locationId: locationId,
                storeName: getStore?.name || "N/A",
                storeAddress: getStore?.address || "N/A"
            };

            // console.log("payload", paylaod);

            await axiosApiFunction('post', '/api/v1/storeclientinfo', {}, "", payload);
            // console.log('Store time info logged successfully', payload);
        } catch (error) {
            console.error('Failed to log store time info:', error);
        }
    };

    return (
        <div>
            <Header setShowLocationPopup={setShowLocationPopup} />
            {showPopup && <AddToCartPopUp onClose={handleAddToCartClosePopup} />}
            {/* <Snackbar
              open={open}
              autoHideDuration={5000}
              onClose={handleClose}
              anchorOrigin={{ vertical: 'top', horizontal: 'right' }} 
            >
              <Alert onClose={handleClose} severity={severity} sx={{ width: '100%' }}>
                {message}
              </Alert>
            </Snackbar> */}
            <Box sx={{ flexGrow: 300 }}>
                <Grid container spacing={0}>
                    <Grid item xs={12} sm={12} md={3} lg={2} xl={2} sx={{
                    '@media (min-width: 1200px) and (max-width: 1365px)': {
                        flexBasis: '20% !important',
                        maxWidth: '20% !important',
                        flexGrow: 0,
                    },
                    }}>
                        <div className="set-lf">
                            <Sidebar
                                onSelectCategory={handleCategorySelect}
                                categorydata={category}
                                selectedCategory={selectedCategory}
                                categoryRefs={categoryRefs}
                                isLoading={isLoading}
                                setShowBogoPopup={setShowBogoPopup}
                                setSelectedBogoCategoryId={setSelectedBogoCategoryId}
                            />
                        </div>
                    </Grid>
                    <Grid item xs={12} sm={12} md={9} lg={10} xl={10} sx={{
                    '@media (min-width: 1200px) and (max-width: 1365px)': {
                        flexBasis: '80% !important',
                        maxWidth: '80% !important',
                        flexGrow: 0,
                    },
                    }}>
                        <div className="product-grid-container">
                        <div className="header-container">
                            <div className="setup-address-store">
                            {Object.keys(getStore).length > 0 && <div className="store-info">
                                <div className="store-details">
                                    <div className="set-store-name-icon">
                                        <div className="icon-names">
                                        <StorefrontOutlinedIcon/>
                                        <div className="sna-setup">
                                            {isLoading ? (
                                                <>
                                                    <Skeleton
                                                        variant="text"
                                                        width="70%"
                                                        height={20}
                                                        sx={{ bgcolor: "#d3d3d3" }} // Skeleton for store name
                                                    />
                                                    <Skeleton
                                                        variant="text"
                                                        width="50%"
                                                        height={15}
                                                        sx={{ bgcolor: "#d3d3d3" }} // Skeleton for store address
                                                    />
                                                </>
                                            ) : (
                                                <>
                                                    <h1 className="store-name">{getStore.name}</h1>
                                                    <h2 className="store-address">{getStore.address}</h2>
                                                </>
                                            )}
                                        </div>
                                        </div>
                                        <div className="icon-names">
                                        <PhoneIphoneOutlinedIcon/>
                                        {isLoading ? (
                                            <Skeleton
                                                variant="text"
                                                width="40%"
                                                height={20}
                                                sx={{ bgcolor: "#d3d3d3" }} // Skeleton for contact phone
                                            />
                                        ) : (
                                                <span>{getStore.contact_phone}</span>
                                        )}
                                        </div>
                                        <div className="icon-names">
                                            <ReceiptLongIcon/>
                                            {isLoading ? (
                                            <Skeleton
                                                variant="text"
                                                width="60%"
                                                height={20}
                                                sx={{ bgcolor: "#d3d3d3" }} // Skeleton for GST note
                                            />
                                        ) : (
                                                <span>{"Prices are exclusive of all taxes and charges"}</span>
                                        )}
                                        </div>
                                    </div>
                                    {((getStore.active == "true" || getStore.active == true) && isStoreOpen(getStore.timings)) ? 
                                        (<div className="store-status open">OPEN
                                            <div className="next-opening-time">
                                                {getNextOpeningTime(getStore.timings)}
                                            </div>
                                        </div>) : 
                                        (<div className="store-status closed">CLOSED
                                            <div className="next-opening-time">
                                                {getNextOpeningTime(getStore.timings)}
                                            </div>
                                        </div>)
                                    }
                                </div>
                                <div 
                                    className="set-location-icon"
                                    onClick={handleLocationClick}
                                    style={{ cursor: "pointer" }}
                                >
                                    <NearMeOutlinedIcon className="search-on-map" />
                                </div>
                            </div>}
                            <div className="store-info">
                                <div className="search-bar-main-box" onClick={handleSearch}>
                                <SearchIcon />
                                {/* <Search onClick={handleSearch}>
                                    <SearchIconWrapper>
                                    <SearchIcon />
                                    </SearchIconWrapper>
                                    <StyledInputBase
                                    placeholder="Search…"
                                    inputProps={{ 'aria-label': 'search' }}
                                    />
                                </Search> */}
                                <p>Search Menu</p>
                                </div>
                                {/* <div className="vn-box">
                                    <span>
                                        <div className="veg-flag"><span></span></div> Pure-Veg
                                    </span>
                                </div> */}
                                <Select
                                    value={sortOrder}
                                    onChange={handleSortChange}
                                    variant="outlined"
                                    className="sort-button"
                                    displayEmpty
                                >
                                    <MenuItem value="" disabled> <img className="sbpimgset" src={sbp} /></MenuItem>
                                    <MenuItem value="asc">Low to High</MenuItem>
                                    <MenuItem value="desc">High to Low</MenuItem>
                                </Select>
                            </div>
                            </div>
                                {/* <Button variant="outlined" className="sort-button" onClick={() => handleClick()}>
                                    Sort by Pricing
                                </Button> */}
                                
                            </div>
                            {/* { apiError && <span style={{color: 'red'}}>{apiError}<br /></span> } */}
                            { offers.length > 0 && <OfferScroller offers={offers} isLoading ={isLoading} /> }
                            { recommendedItems.length > 0 && <RecommendedItems items={recommendedItems} addProductToCart={addProductToCart} isLoading ={isLoading} /> }
                            {/* <Spinner enabled={isLoading} /> */}
                            {isLoading ? (
                                <Grid container spacing={2} className="home-category-grid">
                                    {/* Show skeletons while loading */}
                                    {Array.from({ length: 20 }).map((_, index) => (
                                        <React.Fragment key={index}>{renderSkeleton()}</React.Fragment>
                                    ))}
                                </Grid>
                            ) : (
                                category && (
                                    <Grid container spacing={2} className="home-category-grid">
                                        {category.map((category, index) => (
                                            <React.Fragment key={index}>
                                                {(category.items.length > 0 || (category.subCategories.length > 0 && category.subCategories.some(sub => sub.items.length > 0))) && (
                                                    <h2
                                                        className="divider line one-line category-header title1"
                                                        ref={el => categoryRefs.current[category.refId] = el}
                                                    >
                                                        <span>{category.title}</span>
                                                    </h2>
                                                )}
                                                {/* If category has linkoffer == 1, render CustomBOGOTile */}
                                                {category?.linkoffer && (category?.linkoffer == 1) ? (
                                                    (() => {
                                                        // Find the matching offer data based on category.offerid
                                                        const offerData = offers.find(offer => offer.offerid == category.offerid) || {};
                                                    return (
                                                    <BOGOProductTile getStore={getStore} addProductToCart={addProductToCart} category={category} setShowBogoPopup={setShowBogoPopup} isStoreOpen={isStoreOpen} setSelectedBogoCategoryId={setSelectedBogoCategoryId} offerData={offerData} />
                                                    );
                                                })()
                                                ) : (
                                                    // Otherwise, render normal product items and subcategories
                                                    <>
                                                        {category.items.length > 0 &&
                                                            category.items.map((item, index) => (
                                                                <Grid item xs={12} sm={6} md={6} lg={3} key={index} className="item-cart-category">
                                                                    <Paper className="product-card">
                                                                        <div className="product-box-wc">
                                                                            
                                                                            <div className="pro-contentimg">
                                                                                <img
                                                                                    src={item.imgUrl && item.imgUrl !== null && item.imgUrl !== "" ? item.imgUrl : dummy}
                                                                                    onError={(e) => {
                                                                                        e.target.src = dummy;
                                                                                    }}
                                                                                    alt="Product Image"
                                                                                    className="product-image"
                                                                                    loading="lazy"
                                                                                />
                                                                            </div>
                                                                            <div className="pro-contentbox">
                                                                                <div className="d-flex align-items-center mb-2">
                                                                                    <div className={item.foodType == 1 ? "veg-flag" : "non-vegflag"}>
                                                                                        <span></span>
                                                                                    </div>
                                                                                </div>
                                                                                <div>
                                                                                    <Typography variant="h4" className="pro-title">
                                                                                        {item.title}
                                                                                    </Typography>
                                                                                </div>
                                                                                <div>
                                                                                    <Typography variant="body1" className="product-price">
                                                                                        {(() => {
                                                                                            const firstOption = item?.optionGroups?.find((el) => el.refId == item.refId)?.options?.[0];
                                                                                            const displayPrice = item.price ? item.price : firstOption?.price;
                                                                                            const displayMarkup = item.markupPrice ? item.markupPrice : firstOption?.markupPrice;
                                                                                            return (
                                                                                                <>
                                                                                                    {displayMarkup > displayPrice && (
                                                                                                        <span style={{ textDecoration: "line-through", marginRight: "5px", color: "#888" }}>
                                                                                                            {getStore?.currencysymbol}{displayMarkup}
                                                                                                        </span>
                                                                                                    )}
                                                                                                    {getStore?.currencysymbol}  {displayPrice}
                                                                                                </>
                                                                                            );
                                                                                        })()}
                                                                                    </Typography>
                                                                                </div>
                                                                                <div>
                                                                                <Typography variant="body1" className="product-description">
                                                                                    {expandedDescriptions[item.refId] ? item.description : item.description?.length > 50 ? `${item.description.slice(0, 50)}...` : item.description}
                                                                                    {item.description?.length > 50 && (
                                                                                        <span onClick={() => toggleReadMore(item.refId)} style={{ cursor: 'pointer' }} className="read-more-home">
                                                                                            {expandedDescriptions[item.refId] ? ' Read Less' : ' Read More'}
                                                                                        </span>
                                                                                    )}
                                                                                </Typography>
                                                                                </div>
                                                                                
                                                                            </div>
                                                                        </div>
                                                                        {Object.keys(getStore).length > 0 && (getStore.active == "true" || getStore.active == true) && isStoreOpen(getStore.timings) && 
                                                                        <div className="product-actions">
                                                                            <div className="chips-set">
                                                                                <div>
                                                                                    {item.optionGroups.length > 0 && <Chip label="customize" variant="outlined" size="small" sx={{
                                                                                        borderColor: 'green',
                                                                                        color: 'green',
                                                                                    }} />}
                                                                                </div>
                                                                                <div className="chips-not-avelable">
                                                                                    {(item.available != 1 || item.available != true) && <Chip label="Not available" color="error" variant="outlined" size="small" />}
                                                                                </div>
                                                                            </div>
                                                                            
                                                                            {!(item.available != 1 || item.available != true) && 
                                                                                <div className="addcart-in-de-button">
                                                                                    {isProductInCart(item) ? (<>
                                                                                        <IconButton className="remove-button">
                                                                                            <RemoveIcon onClick={()=> dispatch(decreaseQtyFromCatalogue({refId: item.refId}))}
                                                                                            />
                                                                                        </IconButton>
                                                                                        <Typography variant="body1" style={{ width: '30px', textAlign: 'center', backgroundColor: '#EFEFEF', borderRadius: '10px', margin:'0px 4px', padding: '8px 0px', }}>{getProductQuantityInCart(item)}</Typography>
                                                                                        <IconButton  color="primary"
                                                                                            className="add-button"
                                                                                            onClick={()=> addProductToCart(item, item.price ? item.price : item?.optionGroups.find((el) => el.refId == item.refId)?.options[0].price)}>
                                                                                            <AddIcon />
                                                                                        </IconButton>
                                                                                        </>) : (
                                                                                        <IconButton
                                                                                            color="primary"
                                                                                            className="add-button"
                                                                                            onClick={()=>addProductToCart(item, item.price ? item.price : item?.optionGroups.find((el) => el.refId == item.refId)?.options[0].price)}
                                                                                        >
                                                                                            <AddIcon />
                                                                                        </IconButton>
                                                                                    )}
                                                                            </div>
                                                                            }
                                                                        </div>}
                                                                    </Paper>
                                                                </Grid>
                                                            ))
                                                        }
                                                        {category.subCategories.length > 0 &&
                                                            category.subCategories.map((subcategory, index) => (
                                                                subcategory.items.length > 0 && (
                                                                    <React.Fragment key={index}>
                                                                        <h3
                                                                            className="divider line one-line category-header title2"
                                                                            ref={el => categoryRefs.current[subcategory.refId] = el}
                                                                        >
                                                                        <span>{subcategory.title}</span> 
                                                                        </h3>
                                                                        {subcategory.items.map((item, index) => (
                                                                            <Grid item xs={12} sm={6} md={6} lg={3} key={index} className="item-cart-category">
                                                                                <Paper className="product-card">
                                                                                    <div className="product-box-wc">
                                                                                    <div className="pro-contentimg">
                                                                                            <img
                                                                                                src={item.imgUrl && item.imgUrl !== null && item.imgUrl !== "" ? item.imgUrl : dummy}
                                                                                                onError={(e) => {
                                                                                                    e.target.src = dummy;
                                                                                                }}
                                                                                                alt="Product Image"
                                                                                                className="product-image"
                                                                                                loading="lazy"
                                                                                            />
                                                                                        </div>
                                                                                        <div className="pro-contentbox">
                                                                                            <div className="d-flex align-items-center mb-2">
                                                                                                <div className={item.foodType == 1 ? "veg-flag" : "non-vegflag"}>
                                                                                                    <span></span>
                                                                                                </div>
                                                                                            </div>
                                                                                            <div>
                                                                                                <Typography variant="h4" className="pro-title">
                                                                                                    {item.title}
                                                                                                </Typography>
                                                                                            </div>
                                                                                            <div>
                                                                                                <Typography variant="body1" className="product-price">
                                                                                                    {(() => {
                                                                                                        const firstOption = item?.optionGroups?.find((el) => el.refId == item.refId)?.options?.[0];
                                                                                                        const displayPrice = item.price ? item.price : firstOption?.price;
                                                                                                        const displayMarkup = item.markupPrice ? item.markupPrice : firstOption?.markupPrice;
                                                                                                        return (
                                                                                                            <>
                                                                                                                {displayMarkup > displayPrice && (
                                                                                                                    <span style={{ textDecoration: "line-through", marginRight: "5px", color: "#888" }}>
                                                                                                                        {getStore?.currencysymbol}{displayMarkup}
                                                                                                                    </span>
                                                                                                                )}
                                                                                                                {getStore?.currencysymbol}  {displayPrice}
                                                                                                            </>
                                                                                                        );
                                                                                                    })()}
                                                                                                </Typography>
                                                                                            </div>
                                                                                            <div>
                                                                                            <Typography variant="body1" className="product-description">
                                                                                                {expandedDescriptions[item.refId] ? item.description : item.description?.length > 50 ? `${item.description.slice(0, 80)}...` : item.description}
                                                                                                {item.description?.length > 50 && (
                                                                                                    <span onClick={() => toggleReadMore(item.refId)} style={{ cursor: 'pointer' }} className="read-more-home">
                                                                                                        {expandedDescriptions[item.refId] ? ' Read Less' : ' Read More'}
                                                                                                    </span>
                                                                                                )}
                                                                                            </Typography>
                                                                                            </div>
                                                                                        
                                                                                        </div>
                                                                                        
                                                                                    </div>
                                                                                    
                                                                                    {Object.keys(getStore).length > 0 && (getStore.active == "true" || getStore.active == true) && isStoreOpen(getStore.timings) && <div className="product-actions">
                                                                                        {/* {item.optionGroups.length > 0 && <Button
                                                                                            variant="outlined"
                                                                                            className="customize-button"
                                                                                        >
                                                                                            Customize
                                                                                        </Button>} */}
                                                                                        <div className="chips-set">
                                                                                            <div>
                                                                                                {item.optionGroups.length > 0 && <Chip label="customize" variant="outlined" size="small" sx={{
                                                                                                    borderColor: 'green',
                                                                                                    color: 'green',
                                                                                                }} />}
                                                                                            </div>
                                                                                            <div className="chips-not-avelable">
                                                                                                {(item.available != 1 || item.available != true) && <Chip label="Not available" color="error" variant="outlined" size="small" />}
                                                                                            </div>
                                                                                        </div>
                                                                                        {!(item.available != 1 || item.available != true) && 
                                                                                        <div className="addcart-in-de-button">
                                                                                            {isProductInCart(item) ? (<>
                                                                                                <IconButton className="remove-button" >
                                                                                                    <RemoveIcon onClick={()=> dispatch(decreaseQtyFromCatalogue({refId: item.refId}))} />
                                                                                                </IconButton>
                                                                                                <Typography variant="body1" style={{ width: '30px', textAlign: 'center', backgroundColor: '#EFEFEF', borderRadius: '10px', margin:'0px 4px', padding: '8px 0px', }}>{getProductQuantityInCart(item)}</Typography>
                                                                                                <IconButton  color="primary"
                                                                                                    className="add-button"
                                                                                                    onClick={()=> addProductToCart(item, item.price ? item.price : item?.optionGroups.find((el) => el.refId == item.refId)?.options[0].price)}>
                                                                                                    <AddIcon />
                                                                                                </IconButton>
                                                                                                </>) : (
                                                                                                <IconButton
                                                                                                    color="primary"
                                                                                                    className="add-button"
                                                                                                    onClick={()=>addProductToCart(item, item.price ? item.price : item?.optionGroups.find((el) => el.refId == item.refId)?.options[0].price)}
                                                                                                >
                                                                                                    <AddIcon />
                                                                                                </IconButton>
                                                                                            )}
                                                                                        </div>
                                                                                        }
                                                                                        
            
            
                                                                                        {/* <IconButton
                                                                                            color="primary"
                                                                                            className="add-button"
                                                                                            onClick={()=>addProductToCart(item, item.price ? item.price : item?.optionGroups.find((el) => el.item_ref_ids == item.refId)?.options[0].price)}
                                                                                        >
                                                                                            <AddIcon />
                                                                                        </IconButton>
                                                                                        <IconButton style={{ color: '#fff', backgroundColor: '#000' }} >
                                                                                            <RemoveIcon />
                                                                                        </IconButton>
                                                                                        <Typography variant="body1" style={{ width: '30px', textAlign: 'center', backgroundColor: '#EFEFEF', borderRadius: '10px', margin:'0px 10px', padding: '10px 0px', }}>25</Typography>
                                                                                        <IconButton  color="primary"
                                                                                            className="add-button"
                                                                                            onClick={()=>addProductToCart(item, item.price ? item.price : item?.optionGroups.find((el) => el.item_ref_ids == item.refId)?.options[0].price)}>
                                                                                            <AddIcon />
                                                                                        </IconButton> */}
                                                                                    </div>}
                                                                                </Paper>
                                                                            </Grid>
                                                                        ))}
                                                                    </React.Fragment>
                                                                )
                                                            ))
                                                        }
                                                    </>
                                                )}
                                            </React.Fragment>
                                        ))}
                                    </Grid>
                                )
                            )}
                        </div>
                    </Grid>
                </Grid>
            </Box>
            { openDialog && <DialogComp openDialog={openDialog} setOpenDialog={setOpenDialog} dialogItem={dialogItem} addProductToCart={addProductToCart} />
            }
            <SearchModal openSearchDialog={openSearchDialog} setOpenSearchDialog={setOpenSearchDialog} searchItems={searchItems} addProductToCart={addProductToCart} isStoreOpen={isStoreOpen}/>
            <BOGOWizard 
                open={showBogoPopup}
                onClose={() => setShowBogoPopup(false)}
                bogoCategory={bogoCategory.filter(category => category.refId === selectedBogoCategoryId)}
                addProductToCart={addProductToCart}
                getProductQuantityInCart={getProductQuantityInCart}
                isProductInCart={isProductInCart}
                isStoreOpen={isStoreOpen}
                setShowPopup={setShowPopup}
                convertOptionToPlainObject={convertOptionToPlainObject}
                setSeverity={() => setSeverity('error')}
                setMessage={() => setMessage('Product is not available!')} />
            <ScrollBottomToTop />
            <StoreLocationPopup
                open={showLocationPopup}
                onClose={() => setShowLocationPopup(false)} // Close the pop-up
                onSelectLocation={handleLocationSelect} // Handle location selection
                locations={stores}
            />
            {/* <Footer /> */}
        </div>
    );
}

export default HomePage;
